export const studentEducontRoutes = [
  {
    path: '/educont/invite',
    name: 'educont-invite',
  },
]
